import {UnknownError} from '../../../shared/symbols';
import {DashboardStudy, DashboardUser} from '../../types/dashboard.types';

/**
 * Unique identifier for the dashboard study viewer state.
 */
export const dashboardStateUniqueIdentifier = '__Dashboard__';

export class LoadDashboardUser {
  static readonly type = `${dashboardStateUniqueIdentifier} ${LoadDashboardUser.name}`;

  constructor(public dashboardUserUid: DashboardUser['uid']) {}
}

export class LoadDashboardUserSuccess {
  static readonly type = `${dashboardStateUniqueIdentifier} ${LoadDashboardUserSuccess.name}`;

  constructor(public dashboardUser: DashboardUser) {}
}

export class LoadDashboardUserFail {
  static readonly type = `${dashboardStateUniqueIdentifier} ${LoadDashboardUserFail.name}`;

  constructor(public error: UnknownError) {}
}

export class ResetDashboardUser {
  static readonly type = `${dashboardStateUniqueIdentifier} ${ResetDashboardUser.name}`;
}

export class LoadDashboardStudyDetails {
  static readonly type = `${dashboardStateUniqueIdentifier} ${LoadDashboardStudyDetails.name}`;

  constructor(public dashboardStudyId: DashboardStudy['id']) {}
}

export class LoadDashboardStudyDetailsSuccess {
  static readonly type = `${dashboardStateUniqueIdentifier} ${LoadDashboardStudyDetailsSuccess.name}`;

  constructor(public dashboardStudyDetails: DashboardStudy) {}
}

export class LoadDashboardStudyDetailsFail {
  static readonly type = `${dashboardStateUniqueIdentifier} ${LoadDashboardStudyDetailsFail.name}`;

  constructor(public error: UnknownError) {}
}

export class ResetDashboardStudyDetails {
  static readonly type = `${dashboardStateUniqueIdentifier} ${ResetDashboardStudyDetails.name}`;
}
